import bb from 'blingblingjs';
import {show as showOverlay, hide as hideOverlay} from './page-overlay'; 


// Define State
let state = {
	currentDropdown : false
}

// Define DOM Elements
const trigger 		= bb('.js-fn__header-dropdown-trigger'); // 
const dropdowns 	= bb('.js-el__header-dropdown');
const container		= bb('.js-el__header')[0];


// Event Functions
trigger.on('mouseenter', (e) => {
	state.currentDropdown = e.currentTarget.dataset.menuname;
	update();
});

trigger.on('mouseleave', () => {
	state.currentDropdown = false;
	update();
});


// Update Function
function update(){

	// Set the header class if theres an open dropdown
	container.classList.toggle('--has-open-dropdown', state.currentDropdown);

	// Show / hide the dark page overlay if theres a dropdown showing
	state.currentDropdown ? showOverlay(): hideOverlay();
	
	// Show the current dropdown / hide the others
	dropdowns.forEach(el => {
		el.classList.toggle('--is-open', state.currentDropdown == el.dataset.menuname)
	})

} 

